import { api } from "./api";

export const userDashboardService = {
  fetchOverview(params) {
    return api.get("/user-dashboard-stats/", { params });
  },
};

export default userDashboardService;
